import { Product } from 'entities/product';

// Market-localized price: the Shopify variant amount follows the shopper's
// market; the always-USD plans price is only a fallback while it loads.
export const getLocalizedPrice = (
  product?: Pick<Product, 'price' | 'shopifyData'> | null,
): string | undefined => product?.shopifyData?.price?.amount ?? product?.price;
